import { MaterialType } from "@/models/material.model";
import { QueryParams } from "@/models/query-params.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { BehaviorSubject, map } from "rxjs";

export class ObjectsService {
  private classroomId: string | undefined;

  constructor(private _objects = new StatsRest()) {
    this.classroomId = localStorage.getItem("objClassroomId") ?? undefined;
  }

  objects$ = new BehaviorSubject([]);
  objects = this.objects$.asObservable();

  getMaterialsByObjectiveStats(
    courseId: string,
    objectiveId: string,
    params: QueryParams
  ): void {
    this._objects
      .getMaterialsByObjectiveStats(courseId, objectiveId, {
        ...params,
        classroomId: this.classroomId,
      })
      .pipe(
        map((e: any) => {
          e.content.forEach((item: any) => {
            for (let i = 0; i < item.lessonPlan.length; i++) {
              item.lessonPlan[i] = this.remakeObjectLessonPlan(
                item.lessonPlan[i]
              );
            }
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.objects$.next(response);
        },
      });
  }

  remakeObjectLessonPlan(item: any): any {
    var status = { name: "", class: "", value: "" };
    status.name = this.getLessonPlan(item);
    status.class = this.getLessonPlanColor(item);
    status.value = item;
    return status;
  }

  getLessonPlan(status: string): string {
    if (status == MaterialType.COMPLEMENTARY) {
      status = "Complementar";
    } else if (status == MaterialType.ESSENTIAL) {
      status = "Essencial";
    }
    return status;
  }

  getLessonPlanColor(status: string): string {
    if (status == MaterialType.COMPLEMENTARY) {
      status = "bg-h-primary-200 text-h-primary-500";
    } else if (status == MaterialType.ESSENTIAL) {
      status = "bg-h-secondary-200 text-h-secondary-900";
    }
    return status;
  }
}
